import LoadingLinkCard from './LoadingPlaceholderCard';

const LoadingCards: React.FC<{ items: number[]; show: boolean }> = ({ items, show }) => {

    if (!show) return null;

    return <div className={`row container rel mst-swiper mx-0`}>
        {
            items.map((item, idx) => (

                <div key={idx} className="col px-0 swiper-slide swiper-slide-active">

                    <LoadingLinkCard />

                </div>
            ))
        }
    </div>

}

export default LoadingCards;
